import { Box, Chip, Typography } from "@mui/material";

export default function StepChip({ title }: { title: string }) {
  return (
    <Chip
      label={
        <Typography sx={{ fontWeight: 700, ml: 1, fontSize: "13px" }}>
          {title}
        </Typography>
      }
      variant="outlined"
      sx={{
        alignSelf: "center",
        flexDirection: "row-reverse",
        mb: 2,
      }}
      icon={
        <Box
          sx={{
            backgroundColor: "primary.main",
            width: "25px",
            height: "25px",
            mr: "4px !important",
            ml: "0px !important",
            borderRadius: "12.5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="span"
            sx={{ color: "white" }}
            className="fa-regular fa-check"
          />
        </Box>
      }
    />
  );
}
